import type {
    CreateContentSalesforceObjectAssociationsRequest,
    CreateContentSalesforceObjectAssociationsResponse,
    GetContentSalesforceObjectAssociationsRequest,
    GetContentSalesforceObjectAssociationsResponse,
    Content,
    ContentAction,
    SalesforceAssociation,
} from "@amzn/ads-measurement-plm-service-type-script-client";
import {
    AdsMeasurementPLMClient,
    CreateContentSalesforceObjectAssociationsCommand,
    GetContentSalesforceObjectAssociationsCommand,
} from "@amzn/ads-measurement-plm-service-type-script-client";
import { getCredentialsFromCacheOrCognito } from "@amzn/midway-cognito-type-script-provider";

import { authStore } from "../../store/auth";
import { APPENV } from "../../utils/app.environment";
import { getClientId } from "../adsApi/adsApi.config";

export class PlmApiClient {
    public client: AdsMeasurementPLMClient;

    constructor(client: AdsMeasurementPLMClient) {
        this.client = client;
    }

    getContentSfAssociation: (
        contents: Content[],
    ) => Promise<GetContentSalesforceObjectAssociationsResponse> = async (
        contents,
    ) => {
        const request: GetContentSalesforceObjectAssociationsRequest = {
            userAlias: authStore.getState().username,
            clientId: getClientId(),
            contents,
        };
        return this.client.send(
            new GetContentSalesforceObjectAssociationsCommand(request),
        );
    };

    createContentSfAssociation: (
        content: Content,
        contentAction: ContentAction,
        salesforceAssociations: SalesforceAssociation[],
    ) => Promise<CreateContentSalesforceObjectAssociationsResponse> = async (
        content,
        contentAction,
        salesforceAssociations,
    ) => {
        const request: CreateContentSalesforceObjectAssociationsRequest = {
            userAlias: authStore.getState().username,
            clientId: getClientId(),
            content,
            contentAction,
            salesforceAssociations,
        };
        return this.client.send(
            new CreateContentSalesforceObjectAssociationsCommand(request),
        );
    };
}

export async function getPlmApiClient(): Promise<PlmApiClient> {
    try {
        const {
            settings: { cognitoPoolId, region, plmApiEndpoint },
        } = authStore.getState();

        if (!plmApiEndpoint) {
            throw new Error("PLM API endpoint not yet defined");
        }

        const { accessKeyId, secretAccessKey, sessionToken } =
            await getCredentialsFromCacheOrCognito({
                region,
                identityPoolId: cognitoPoolId,
                clientId: window.location.host,
                redirectUri: window.location.href,
            });

        const client = new AdsMeasurementPLMClient({
            endpoint: `${
                APPENV.mock_server ? "http" : "https"
            }://${plmApiEndpoint}`,
            region,
            credentials: { accessKeyId, secretAccessKey, sessionToken },
        });

        return new PlmApiClient(client);
    } catch (e: any) {
        throw new Error(`Failed to initialize PlmApiClient: ${e.message}`);
    }
}
